import React from 'react';
import Icon from "../";
export default function IconClear(props) {
  return React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<path d=\"M12 2a10 10 0 1010 10A10 10 0 0012 2zm4.36 13.65l-.71.71L12 12.71l-3.65 3.65-.71-.71L11.29 12 7.64 8.35l.71-.71L12 11.29l3.65-3.65.71.71L12.71 12z\" fill=\"#181818\"/>"
    }
  }));
}